import { all, put, takeLatest } from "redux-saga/effects";
import { doGet } from "../utils/request";
import {
    getTehsilesOfDistrictSuccess,
    getTehsilesOfDistrictFail
} from "../actionCreators/Tehsiles"

function* getTehsilesOfDistrict({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/tehsils?districtId=${obj?.district_id}`
    );
    yield put(getTehsilesOfDistrictSuccess(response.data));
  } catch (err) {
    yield put(getTehsilesOfDistrictFail(err.response.data.message || err.message));
    yield put(getTehsilesOfDistrictFail());
  }
}


export default function* watcher() {
  yield all([
    takeLatest("TEHSILES_BY_DISTRICT", getTehsilesOfDistrict),
  ]);
}
